import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../api';
import api from '../../api/endpoints';
import { prepareFilters } from '../../components/Filters/request';

// const prepareDataTable = data => {
//   const dataTable = [];
//
//   data.forEach(item => {
//     const el = {
//       ...item.regular_user,
//       key: item.regular_user.uuid,
//       creator: {
//         uuid: item.regular_user.uuid,
//         avatar_url: item.regular_user.avatar_url,
//         avatar_params: item.regular_user.avatar_params,
//         name: item.regular_user.name,
//         social_accounts: item.regular_user.social_accounts
//       },
//       links: item.lifetime_links,
//       clicks: item.lifetime_clicks,
//       sales: item.lifetime_gmv,
//       last_link_shared: item.last_link_shared,
//       campaigns: item.top_campaigns,
//       groups: item.top_groups,
//       select: { id: item.regular_user.uuid, value: false },
//       operations: item.regular_user
//     };
//     dataTable.push(el);
//   });
//
//   return dataTable;
// };

function* getDiscoverBrands({ payload: { signal, filters, searchQ, curr_page } }) {
  try {

    const { data } = yield call(fetch, {
      api: api.discover.brands,
      params: {
        page: curr_page,
        ...(searchQ && { q: searchQ })
      },
      data: {
        ...prepareFilters(filters),
        ...(searchQ && { q: searchQ })
      },
      signal
    });

    const preparedData = {
      // dataTable: prepareDataTable(data.results),
      dataTable: data.results,
      message: data.message,
      count: data.count,
      next: data.next,
      previous: data.next
    };

    yield put(actions.getDiscoverBrandsDone(preparedData));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.getDiscoverBrandsFailed,
      endpoint: api.discover.brands.url
    });
  }
}

export const getDiscoverBrandsSaga = takeEvery(types.GET_DISCOVER_BRANDS_REQUEST, getDiscoverBrands);